export default function (Component) {
Component.options.__docs = "<p>Use the <code>separated</code> modifier on <code>FdMenuList</code> to add separators between the items.</p>\n"
}